module.exports = __webpack_public_path__ + "static/img/13.20d63fe1.png";